
import { OrderActionType } from '@/store/modules/orders/interfaces/action-type'
import { defineComponent } from 'vue'
import AsahiButton from '@/components/library/AsahiButton.vue'

export default defineComponent({
  name: 'OnBehalfOrder',
  components: { AsahiButton },
  data () {
    return {
      isSeen: false
    }
  },
  computed: {

    isNotDWAM ():boolean {
      return !(this.$store.state.auth.user?.permissionSchema?.[0]?.rpDetails[0]?.rolename === 'Distributor Wholesale Area Manager')
    },
    pendingOrdersList () {
      return this.$store.state.orders.pendingOrderList
    },
    user () {
      return this.$store.state.auth.user
    }
  },
  mounted () {
    const isSeen = localStorage.getItem('clickedBehalfOrder')
    this.isSeen = isSeen !== null
    console.log(this.isSeen)
  },
  methods: {
    redirectToPending () {
      window.localStorage.setItem('clickedBehalfOrder', 'true')
      this.$navigate('/orders/pending')
    }
  }
})
